import Card from "@ui-kit/data-display/Card/Card.web";
import ReadMore from "@ui-kit/typography/ReadMore/ReadMore.web";
import Button from "@ui-kit/form/Button/Button.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Box from "@ui-kit/layout/Box/Box.web";
import Text from "@ui-kit/typography/Text/Text.web";
import { useTranslation } from "@shared/utils/internationalization";
import React from "react";
import Icon from "@ui-kit/icons/Icon.web";
import { enums } from "@shared/constants";
import Link from "@ui-kit/navigation/Link/Link.web";

const PURCHASE_BUTTON_ENUM =
  enums.INITIATE_PURCHASE_BUTTON_DESCRIPTION_MAP_BY_ID;

export interface AttractionRedirectItemProps {
  buttonText: keyof typeof enums.INITIATE_PURCHASE_BUTTON_DESCRIPTION_MAP_BY_ID;
  sectionTitle: string;
  sectionDescription: string;
  sectionUrl: string;
}

const AttractionRedirectItem: React.FC<AttractionRedirectItemProps> = ({
  buttonText,
  sectionTitle,
  sectionDescription,
  sectionUrl,
}) => {
  const { t } = useTranslation("purchases");

  return (
    <>
      <Card
        w="full"
        display="flex"
        flexDirection="column"
        rounded={{ base: "none", sm: "lg" }}
      >
        <Flex
          justifyContent="space-between"
          alignItems={{ base: "flex-start", xs: "center" }}
          direction={{ base: "column", xs: "row" }}
        >
          <Text
            textAlign="left"
            wordBreak="break-word"
            fontSize={{ base: "md", sm: "lg" }}
            fontWeight="bold"
            color="primary.600"
          >
            {sectionTitle}
          </Text>
          <Box minW="element.lg" />

          <Link href={sectionUrl} target="_blank" p="none">
            <Button
              data-testid="redirect-selector-button"
              colorPalette="primary"
              variant="solid"
              mt={{ base: "4", xs: "none" }}
              minWidth={{ base: "100%", xs: "147px" }}
              rightIcon={<Icon.LeavePage outline width="element.md" />}
            >
              {PURCHASE_BUTTON_ENUM[buttonText]?.name
                ? (t(PURCHASE_BUTTON_ENUM[buttonText].name, {
                    ns: "constants",
                  }) as string)
                : t("Find Tickets")}
            </Button>
          </Link>
        </Flex>

        {sectionDescription && (
          <ReadMore
            openReadMoreText={t("Read More")}
            closeReadMoreText={t("Show Less")}
            descriptionHtml={sectionDescription}
          />
        )}
      </Card>
    </>
  );
};

export default AttractionRedirectItem;
